import { render, staticRenderFns } from "./MgrGQ.vue?vue&type=template&id=68b2d9d7&scoped=true&"
import script from "./MgrGQ.vue?vue&type=script&lang=js&"
export * from "./MgrGQ.vue?vue&type=script&lang=js&"
import style0 from "./MgrGQ.vue?vue&type=style&index=0&lang=css&"
import style1 from "./MgrGQ.vue?vue&type=style&index=1&id=68b2d9d7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68b2d9d7",
  null
  
)

export default component.exports